const DEFAULT_CAPI_URL = "/api/meta-capi";

function readCookie(name) {
  if (typeof document === "undefined" || !document.cookie) return undefined;
  const parts = document.cookie.split("; ");
  const prefix = `${name}=`;
  const match = parts.find((part) => part.startsWith(prefix));
  if (!match) return undefined;
  const value = match.slice(prefix.length);
  return value ? decodeURIComponent(value) : undefined;
}

function newEventId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function shouldSendMetaCapi() {
  if (process.env.REACT_APP_FB_PIXEL !== "true") return false;
  if (typeof window === "undefined") return false;
  return window.location.hostname !== "localhost";
}

/**
 * Fire one Meta event on the browser pixel (when fbq exists) and the same
 * event_id on first-party CAPI. One id per call — never reuse across
 * PageView and ViewContent.
 */
export function trackMetaEvent(eventName, { custom = false, userData } = {}) {
  const eventId = newEventId();

  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    if (custom) {
      window.fbq("trackCustom", eventName, {}, { eventID: eventId });
    } else {
      window.fbq("track", eventName, {}, { eventID: eventId });
    }
  }

  if (shouldSendMetaCapi()) {
    const fbp = readCookie("_fbp");
    const fbc = readCookie("_fbc");
    const payload = {
      event_name: eventName,
      event_id: eventId,
      event_source_url: window.location.href,
    };
    if (fbp) payload.fbp = fbp;
    if (fbc) payload.fbc = fbc;
    if (userData) {
      Object.entries(userData).forEach(([key, value]) => {
        if (value) payload[key] = value;
      });
    }

    const url = process.env.REACT_APP_META_CAPI_URL || DEFAULT_CAPI_URL;
    fetch(url, {
      method: "POST",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }).catch(() => {});
  }

  return eventId;
}
